import { all, call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessage } from "utils/sagasErrorHandler";
import {
    getKeywordScanStats,
    getKeywordScanStatsSuccess,
    getKeywordScanStatsError,
} from "modules/Metric/services/MetricKeywordScanStats/actions";
import { getKeywordScanStatsRequest } from "modules/Metric/services/MetricKeywordScanStats/api";

function* handleGetKeywordScanStats({ payload }) {
    try {
        const forceRefresh = payload && payload.force_refresh;
        const response = yield call(getKeywordScanStatsRequest, forceRefresh);

        yield put(getKeywordScanStatsSuccess(response));
    } catch (error) {
        yield put(getKeywordScanStatsError());
        getErrorMessage(error);
    }
}

export function* keywordScanStatsSagas() {
    yield all([
        yield takeLatest(getKeywordScanStats, handleGetKeywordScanStats),
    ]);
}
